module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/february/mainvisual-title@2x_169e0242bd74bc3c7bab2d5284a36e7e.png";